/**
 * Centro Terapéutico Cubic RESTFull API
 * Centro Terapéutico Cubic Endpoints
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Event {
    id: string;
    parentId?: string;
    oldStart?: Date;
    start: Date;
    end: Date;
    type: EventTypeEnum;
    usersId: Array<string>;
    clientsId?: Array<string>;
    treatmentId?: string;
    cancellationType?: EventCancellationTypeEnum;
    cancellationSubType?: EventCancellationSubTypeEnum;
    cancellationReason?: string;
    comments?: Array<string>;
    boardCard?: string;
    title?: string;
    isPaid?: boolean;
    isRecovered?: boolean;
    isRecovery?: boolean;
    paidDate?: Date;
    extraInfo?: object;
}
export enum EventTypeEnum {
    session = 'session',
    firstInterview = 'firstInterview',
    internalMeeting = 'internalMeeting',
    other = 'other',
    meta = 'meta',
    empty = 'empty'
};
export enum EventCancellationTypeEnum {
    reason = 'reason',
    noReason = 'noReason'
};
export enum EventCancellationSubTypeEnum {
    advanceNotice = 'advanceNotice',
    clientIllness = 'clientIllness',
    userIllness = 'userIllness'
};



